export const normatividad_item = [
    {
        "normatividad_item_nombre" : "Contraloria social",
        "normatividad_item_descripcion" : "Comité de Contraloría Social del Programa Música para el Pueblo",
        "normatividad_item_url" : "/Csocial"
    },
    {
        "normatividad_item_nombre" : "Contraloria social 2022",
        "normatividad_item_descripcion" : "Comité de Contraloría Social del Programa ReactivArte",
        "normatividad_item_url" : "/Csociale"
    },
    {
        "normatividad_item_nombre" : "Comité de Ética y Prevención de Conflictos de Interés",
        "normatividad_item_descripcion" : "Comité de Ética y Prevención de Conflictos de Interés",
        "normatividad_item_url" : "/Cetica"
    },
     {
        "normatividad_item_nombre" : "PID  2023-2028",
        "normatividad_item_descripcion" : "Programa Institucional de Desarrollo",
        "normatividad_item_url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir1/2023/transparencia/cocodi/2023/1.6 Programa Institucional de Desarrollo CECULTAH  20_dic_2023.pdf"
    },
]